module.exports = __webpack_public_path__ + "img/19.017955d4.png";